import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Route, Switch } from "react-router-dom";
import { config } from "../../config";
import Api from "../../lib/Api";
import Auth from "../../lib/Auth";
import DataStore from "../../lib/DataStore";
import Locale from "../../lib/Locale";
import MTBHome from "../../pages/Homes/MTBHome";
import RaceHome from "../../pages/Homes/RaceHome";
import BeforeResults from "./BeforeResults";
import Brand from "./Brand";
import Experience from "./Experience";
import Gender from "./Gender";
import Image from "./Image";
import Integration from "./Integration/Integration";
import ParcourType from "./ParcourType";
import Price from "./Price";
import Result from "./Result";
import Summary from "./Result/Summary";
import GeoWeighing from "./Result/WeighingFactor/GeoWeighing";
import PartWeighing from "./Result/WeighingFactor/PartWeighing";
import BeforeSizes from "./Sizes/BeforeSizes";
import Body from "./Sizes/Body";
import Mtb from "./Sizes/Mtb";
import Race from "./Sizes/Race";
import Speed from "./Speed";
import Suspension from "./Suspension";
import Usage from "./Usage";


class Trajectory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            dataParams: DataStore.getValues(),
            flowParams: {
                experience: this.getValue('experience'),
                parcourType: this.getValue('parcourType'),
                mtbType: this.getValue('mtbType'),
                usage: this.getValue('usage'),
                speed: this.getValue('speed'),
                suspension: this.getValue('suspension'),
                brands: this.getValue('brands'),
                image: this.getValue('image'),
                price: this.getValue('price'),
                maxWeight: this.getValue('max_weight'),
                measure: this.getValue('measure'),
                chosenIntegrationOption: this.getValue('chosenIntegrationOption'),
                beforeSizes: this.getValue('beforeSizes'),
                position: this.getValue('position'),
                filterFrame: this.getValue('filterFrame'),
                filterBrake: this.getValue('filterBrake'),
                filterChainRings: this.getValue('filterChainRings'),
                filterYear: this.getValue('filterYear'),
                cassette: this.getValue('cassette'),
                sorting: this.getValue('sorting') || 'BALANCED',
                driveChainWeight: this.getValue('driveChainWeight'),
                suspensionWeight: this.getValue('suspensionWeight'),
                wheelsWeight: this.getValue('wheelsWeight'),
                brakesWeight: this.getValue('brakesWeight'),
                guaranteeWeight: this.getValue('guaranteeWeight'),
                weightWeight: this.getValue('weightWeight'),
                savedResults: this.getValue('savedResults'),
                lastUsedMeasure: this.getValue('lastUsedMeasure')

            },
            selectedOne: this.getSelected(),
            loading: 0,
            traject: props.traject,
            appConfig: {}
        };
    }

    componentDidMount() {
        // this.fetchApiConfig();
    }

    render() {
        const home = (this.props.traject === 'mtb') ? () => <MTBHome /> : () => <RaceHome />

        return (
            <Switch>
                <Route exact path={`${this.props.path}`} render={home} />

                <Route path={`${this.props.path}/advice/experience`} render={() => <Experience
                    traject={this.props.traject}
                    handler={this.setExperience}
                    experience={this.state.flowParams.experience}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/parcour_type`} render={() => <ParcourType
                    traject={this.props.traject}
                    handler={this.setParcourType}
                    parcourType={this.state.flowParams.parcourType}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/usage`} render={() => <Usage
                    traject={this.props.traject}
                    handler={this.setUsage}
                    usage={this.state.flowParams.usage}
                    mtbType={this.state.flowParams.mtbType}
                    type={this.state.flowParams.parcourType}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/speed`} render={() => <Speed
                    traject={this.props.traject}
                    handler={this.setSpeed}
                    speed={this.state.flowParams.speed}
                    type={this.state.flowParams.mtbType}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/suspension`} render={() => <Suspension
                    traject={this.props.traject}
                    handler={this.setSuspension}
                    suspension={this.state.flowParams.suspension}
                    type={this.state.flowParams.parcourType}
                    usage={this.state.flowParams.usage}
                    mtbType={this.state.flowParams.mtbType}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/image`} render={() => <Image
                    traject={this.props.traject}
                    handler={this.setImage}
                    image={this.state.flowParams.image}
                    usage={this.state.flowParams.usage}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/brand`} render={() => <Brand
                    traject={this.props.traject}
                    bikeType={this.state.flowParams.mtbType}
                    handler={this.setBrands}
                    selectedBrands={this.state.flowParams.brands}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/gender`} render={() => <Gender
                    traject={this.props.traject}
                    genderHandler={this.setGender}
                    sexHandler={this.setSex}
                    usage={this.state.flowParams.usage}
                    ageHandler={this.setAge}
                    gender={this.state.dataParams.gender}
                    sex={this.state.dataParams.sex}
                    age={this.state.dataParams.age}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/integration`}
                        render={() => (
                            <Integration
                              traject={this.props.traject}
                              goTo={this.goTo}
                              get={this.get}
                              post={this.post}
                              measure={this.state.flowParams.measure}
                              setChosenIntegrationOption={this.setChosenIntegrationOption}
                              chosenIntegrationOption={this.state.flowParams.chosenIntegrationOption}
                              setSavedResults={this.setSavedResults}
                              setMeasureBikefit={this.setMeasureBikefit}
                              parcourType={this.getValue("parcourType")}
                              mtbType={this.getValue("mtbType")}
                            />
                          )}
                        />

                <Route exact path={`${this.props.path}/advice/sizes`} render={() => <BeforeSizes
                    traject={this.props.traject}
                    handler={this.setBeforeSizes}
                    setNoFit={this.setNoFit}
                    mtbType={this.state.flowParams.mtbType}
                    measure={this.state.flowParams.measure}
                    beforeSizes={this.state.flowParams.beforeSizes}
                    chosenIntegrationOption={this.state.flowParams.chosenIntegrationOption}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/sizes/body`} render={() => <Body
                    traject={this.props.traject}
                    handler={this.setSizes}
                    position={this.state.flowParams.position}
                    length={this.state.dataParams.length}
                    age={this.state.dataParams.age}
                    arm={this.state.dataParams.arm}
                    romp={this.state.dataParams.romp}
                    leg={this.state.dataParams.leg}
                    weight={this.state.dataParams.weight}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/sizes/mtb`} render={() => (
                    <Mtb
                        traject={this.props.traject}
                        handler={this.setMtbSizes}
                        sadleheight={this.state.dataParams.mtbSadleheight}
                        setback={this.state.dataParams.mtbSetback}
                        mtbLength={this.state.dataParams.mtbLength}
                        sadleground={this.state.dataParams.mtbSadleground}
                        steerground={this.state.dataParams.mtbSteerground}
                        mtbSuspension={this.state.dataParams.mtbSuspension}
                        fully={this.state.dataParams.mtbFully}
                        goTo={this.goTo}
                        get={this.get}
                        post={this.post}
                    />
                )
                } />

                <Route path={`${this.props.path}/advice/sizes/race`} render={() => (
                    <Race
                        traject={this.props.traject}
                        handler={this.setRaceSizes}
                        sadleheight={this.state.raceSadleheight}
                        setback={this.state.raceSetback}
                        raceLength={this.state.raceLength}
                        drop={this.state.raceDrop}
                        sadleground={this.state.raceSadleground}
                        steerground={this.state.raceSteerground}
                        goTo={this.goTo}
                        get={this.get}
                        post={this.post}
                    />
                )}
                />

                <Route path={`${this.props.path}/advice/price`} render={() => <Price
                    traject={this.props.traject}
                    experience={this.state.flowParams.experience}
                    speed={this.state.flowParams.speed}
                    suspension={this.state.flowParams.suspension}
                    usage={this.state.flowParams.usage}
                    mtbType={this.state.flowParams.mtbType}
                    chosenIntegrationOption={this.state.flowParams.chosenIntegrationOption}
                    image={this.state.flowParams.image}
                    handler={this.setPrice}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                    priceMax={20000}
                />} />

                <Route path={`${this.props.path}/advice/result`} render={() => <Result
                    traject={this.props.traject}
                    path={this.props.path}
                    bikeType={this.state.flowParams.mtbType}
                    mtb_type={this.state.flowParams.mtbType}
                    experience={this.state.flowParams.experience}
                    parcourType={this.state.flowParams.parcourType}
                    usage={this.state.flowParams.usage}
                    speed={this.state.flowParams.speed}
                    suspension={this.state.flowParams.suspension}
                    sex={this.state.dataParams.sex}
                    gender={this.state.dataParams.gender}
                    age={this.state.dataParams.age}
                    measure={this.state.flowParams.measure}
                    position={this.state.flowParams.position}
                    length={this.state.dataParams.length}
                    arm={this.state.dataParams.arm}
                    romp={this.state.dataParams.romp}
                    inner_leg={this.state.dataParams.leg}
                    weight={this.state.dataParams.weight}
                    shoe_size={this.state.dataParams.shoe_size}
                    mtbSadleheight={this.state.dataParams.mtbSadleheight}
                    mtbSetback={this.state.dataParams.mtbSetback}
                    mtbLength={this.state.dataParams.mtbLength}
                    mtbDrop={this.state.dataParams.mtbDrop}
                    mtbSuspension={this.state.dataParams.mtbSuspension}
                    mtbFully={this.state.dataParams.mtbFully}
                    mtbSadleground={this.state.dataParams.mtbSadleground}
                    mtbSteerground={this.state.dataParams.mtbSteerground}
                    raceSadleheight={this.state.dataParams.raceSadleheight}
                    raceSetback={this.state.dataParams.raceSetback}
                    raceLength={this.state.dataParams.raceLength}
                    raceDrop={this.state.dataParams.raceDrop}
                    raceSteerground={this.state.dataParams.raceSteerground}
                    raceSadleground={this.state.dataParams.raceSadleground}
                    image={this.state.flowParams.image}
                    selectedBrands={this.state.flowParams.brands}
                    price={this.state.flowParams.price}
                    maxWeight={this.state.flowParams.maxWeight}
                    changePrice={this.setPrice}
                    setLastUsedMeasure={this.setLastUsedMeasure}
                    setWeight={this.setWeight}
                    select={this.setSelected}
                    sorting={this.state.flowParams.sorting}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                    handler={this.setBrands}
                    setSex={this.setSex}
                    setPosition={this.setPosition}
                    setSuspension={this.setSuspension}
                    filterFrame={this.state.flowParams.filterFrame}
                    setFilterFrame={this.setFilterFrame}
                    filterBrake={this.state.flowParams.filterBrake}
                    setFilterBrake={this.setFilterBrake}
                    filterChainRings={this.state.flowParams.filterChainRings}
                    setFilterChainRings={this.setFilterChainRings}
                    filterYear={this.state.flowParams.filterYear}
                    setFilterYear={this.setFilterYear}
                    cassette={this.state.flowParams.cassette}
                    setCassette={this.setCassette}
                    driveChainWeight={this.state.flowParams.driveChainWeight}
                    suspensionWeight={this.state.flowParams.suspensionWeight}
                    wheelsWeight={this.state.flowParams.wheelsWeight}
                    brakesWeight={this.state.flowParams.brakesWeight}
                    guaranteeWeight={this.state.flowParams.guaranteeWeight}
                    weightWeight={this.state.flowParams.weightWeight}
                    savedResults={this.state.flowParams.savedResults}
                    chosenIntegrationOption={this.state.flowParams.chosenIntegrationOption}
                />} />

                <Route path={`${this.props.path}/advice/result_bike`} render={() => <Summary
                    traject={this.props.traject}
                    bikeType={this.state.flowParams.mtbType}
                    appConfig={this.state.appConfig}
                    selectedOne={this.state.selectedOne}
                    position={this.state.flowParams.position}
                    lastUsedMeasure={this.state.flowParams.lastUsedMeasure}
                    chosenIntegrationOption={this.state.flowParams.chosenIntegrationOption}
                    length={this.state.dataParams.length}
                    arm={this.state.dataParams.arm}
                    romp={this.state.dataParams.romp}
                    inner_leg={this.state.dataParams.leg}
                    weight={this.state.dataParams.weight}
                    shoe_size={this.state.dataParams.shoe_size}
                    usage={this.state.flowParams.usage}
                    setMeasureBikefit={this.setMeasureBikefit}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/advice/beforeresults`} render={() => <BeforeResults
                    traject={this.props.traject}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/weighing-factors/parts`} render={() => <PartWeighing
                    traject={this.props.traject}
                    setPartWeighing={this.setPartWeighing}
                    driveChainWeight={this.state.flowParams.driveChainWeight}
                    suspensionWeight={this.state.flowParams.suspensionWeight}
                    wheelsWeight={this.state.flowParams.wheelsWeight}
                    brakesWeight={this.state.flowParams.brakesWeight}
                    guaranteeWeight={this.state.flowParams.guaranteeWeight}
                    weightWeight={this.state.flowParams.weightWeight}

                    speed={this.state.flowParams.speed}
                    position={this.state.flowParams.position}
                    image={this.state.flowParams.image}
                    experience={this.state.flowParams.experience}
                    parcourType={this.state.flowParams.parcourType}
                    usage={this.state.flowParams.usage}
                    suspension={this.state.flowParams.suspension}
                    sex={this.state.dataParams.sex}
                    gender={this.state.dataParams.gender}
                    price={this.state.flowParams.price}
                    weight={this.state.dataParams.weight}
                    length={this.state.dataParams.length}
                    inner_leg={this.state.dataParams.leg}
                    romp={this.state.dataParams.romp}
                    age={this.state.dataParams.age}
                    arm={this.state.dataParams.arm}
                    shoe_size={this.state.dataParams.shoe_size}

                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                />} />

                <Route path={`${this.props.path}/weighing-factors/geo`} render={() => <GeoWeighing
                    traject={this.props.traject}
                    goTo={this.goTo}
                    get={this.get}
                    post={this.post}
                    measure={this.state.flowParams.measure}
                    setSorting={this.setSorting}
                    sorting={this.state.flowParams.sorting}
                />} />

            </Switch>
        )
    }




  getValue = (key) => {
    const storageKey = `${this.props.traject}_${key}`;
    return localStorage.getItem(storageKey);
  };

  setValue = (params) => {
    this.setState({ settingValue: true });

    let newFlowParams = this.state.flowParams;
    let newDataParams = this.state.dataParams;

    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        const storageKey = `${this.props.traject}_${key}`;
        const value = params[key];

        if (DataStore.isKey(key)) {
          DataStore.setValue({ [key]: value });
          newDataParams[key] = value;
        } else {
          if (value === null) {
            localStorage.removeItem(storageKey);
          } else {
            localStorage.setItem(storageKey, value);
          }
          newFlowParams[key] = value;
        }
      }
    }

    return new Promise((resolve, reject) => {
      if (Auth.isLoggedIn()) {
        this.setState(
          { flowParams: newFlowParams, dataParams: newDataParams },
          () => this.setState({ settingValue: false })
        );
        DataStore.pushData()
          .then(() => resolve())
          .catch(() => reject())
          .finally(() => this.setState({ settingValue: false }));
      } else {
        this.setState(
          { flowParams: newFlowParams, dataParams: newDataParams },
          () => {
            this.setState({ settingValue: false });
            resolve();
          }
        );
      }
    });
  };

  setFilterFrame = (filterFrame) => {
    return this.setValue({ filterFrame: filterFrame.join(", ") });
  };

  setFilterBrake = (filterBrake) => {
    return this.setValue({ filterBrake: filterBrake });
  };

  setFilterChainRings = (filterChainRings) => {
    return this.setValue({ filterChainRings: filterChainRings.join(", ") });
  };

  setFilterYear = (year) => {
    return this.setValue({ filterYear: year });
  };

  setCassette = (cassette) => {
    return this.setValue({ cassette: cassette.join(", ") });
  };

  setExperience = (value) => {
    return this.setValue({ experience: value });
  };

  setParcourType = (value) => {
    return this.setValue({ parcourType: value });
  };

  setUsage = (usage, mtbType) => {
    return this.setValue({ usage: usage, mtbType: mtbType });
  };

  setSpeed = (value) => {
    return this.setValue({ speed: value });
  };

  setSuspension = (value) => {
    return this.setValue({ suspension: value });
  };

  setImage = (value) => {
    localStorage.removeItem("brands");
    return this.setValue({ image: value, brands: "" });
  };

  setBrands = (brands) => {
    return this.setValue({ brands: brands.join(", ") });
  };

  setNewBikefit = (value) =>{
    return this.setValue({newBikefit: value})
  }

  setLastUsedMeasure = measure => {
    return this.setValue({ lastUsedMeasure: measure });
  };

  setSex = (value) => {
    return this.setValue({ sex: value });
  };

  setGender = (value) => {
    return this.setValue({ gender: value });
  };

  setAge = (value) => {
    return this.setValue({ age: value });
  };

  setBeforeSizes = (value) => {
    return this.setValue({ beforeSizes: value });
  };

  setNoFit = () => {
    return this.setValue({ measure: "no" });
  };

  setMeasureBikefit = () => {
    return this.setValue({ measure: "bikefit" });
  };

  setChosenIntegrationOption = (value) => {
    return this.setValue({ chosenIntegrationOption: value});
  };

  setSavedResults = (value) => {
    return this.setValue({ savedResults: value });
  };

  setPosition = (position) => {
    return this.setValue({ position });
  };

  setSizes = (position, length, arm, romp, leg, weight) => {
    return this.setValue({
      position: position,
      length: length,
      arm: arm,
      romp: romp,
      leg: leg,
      weight: weight,
      measure: "body",
    });
  };

  setMtbSizes = (
    sadleheight,
    setback,
    mtbLength,
    sadleground,
    steerground,
    mtbSuspension,
    fully
  ) => {
    return this.setValue({
      mtbSadleheight: sadleheight,
      mtbSetback: setback,
      mtbLength: mtbLength,
      mtbSadleground: sadleground,
      mtbSteerground: steerground,
      mtbSuspension: mtbSuspension,
      mtbFully: fully,
      measure: "mtb",
    });
  };

  setRaceSizes = (
    sadleheight,
    setback,
    raceLength,
    drop,
    raceSteerground,
    raceSadleground
  ) => {
    return this.setValue({
      raceSadleheight: sadleheight,
      raceSetback: setback,
      raceLength: raceLength,
      raceDrop: drop,
      raceSteerground: raceSteerground,
      raceSadleground: raceSadleground,
      measure: "race",
    });
  };

  setPrice = (value) => {
    return this.setValue({ price: value });
  };

  setWeight = (value) => {
    return this.setValue({ weight: value });
  };

  setSorting = (sorting) => {
    return this.setValue({ sorting: sorting });
  };

  getSelected = () => {
    if (localStorage.getItem("selectedOne")) {
      return JSON.parse(localStorage.getItem("selectedOne"));
    }
  }

    setSelected = (obj) => {
        // this special parameter doesn't to be saved in account settings?
        this.setState({ selectedOne: obj });
        localStorage.setItem('selectedOne', JSON.stringify(obj));
    };

    setPartWeighing = (chainRings,
        suspension,
        wheels,
        brakes,
        guarantee,
        weight) => {
        return this.setValue({
            driveChainWeight: chainRings,
            suspensionWeight: suspension,
            wheelsWeight: wheels,
            brakesWeight: brakes,
            guaranteeWeight: guarantee,
            weightWeight: weight
        });
    };

    goTo = (url, traject) => {
        if (traject === undefined) {
            this.props.history.push(Locale.getUrlForCurrentLocale(url));
        } else if (config.defaultTraject.toLowerCase() !== traject.toLowerCase()) {
            if (traject === 'race') {
                window.location = Locale.getUrlForCurrentLocale(config.raceUrl + '/road' + url);
            } else if (traject === 'mtb') {
                window.location = Locale.getUrlForCurrentLocale(config.mtbUrl + '/mtb' + url);
            }
            else if (traject === 'bikefit') {
                window.location = Locale.getUrlForCurrentLocale(config.bikefitUrl + '/bikefit' + url);
            }
        } else {
            if (traject === 'race') {
                this.props.history.push(Locale.getUrlForCurrentLocale('/road' + url));
            } else if (traject === 'mtb') {
                this.props.history.push(Locale.getUrlForCurrentLocale('/mtb' + url));
            }
            else if (traject === 'bikefit') {
                this.props.history.push(Locale.getUrlForCurrentLocale('/bikefit' + url));
            }
        }
    };

    fetchApiConfig = () => {
        Api.get('/getconfig', {}).then(response => {
            this.setState({ appConfig: response.data.data });
        }).catch(response => {
            console.log('error');
            console.log(response);
        })
    };
}


export default withTranslation("common")(Trajectory);
